import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import QRCode from 'qrcode.react';
import { generateAssetsBarcode } from '../../../actions/inventory';
import ButtonScogoPrimary from '../../../common/Buttons/ButtonScogoPrimary';
import ButtonScogoClosedOutlined from '../../../common/Buttons/ButtonScogoClosedOutlined';
import { validateStringValue } from '../../../utils/common';
import { useMemo } from 'react';

const formName = 'downLoadQrCode';

const DownloadQR = ({ asset }) => {
    const dispatch = useDispatch();
    const { formButtonLoading } = useSelector((state) => state.loading);

    const handleSubmit = () => {
        dispatch(generateAssetsBarcode({ payload: { assets: [asset.asset.id] }, formName }));
    };

    const closeModal = () => {
        dispatch(closeModalAction());
    };

    let assetNumber = validateStringValue(asset?.asset?.asset_number);
    let organizationName = validateStringValue(asset?.asset?.organization?.name);

    const tagDetailValue = useMemo(() => {
        if (asset?.asset?.tag_id || asset?.asset?.serial_number || asset?.asset?.asset_number) {
            return asset?.asset?.tag_id || asset?.asset?.serial_number || asset?.asset?.asset_number;
        }
        return `${window.location.origin}`;
    }, [asset]);

    return (
        <div className="flex flex-col">
            <div className="bg-gray-50 rounded-lg px-6 py-3 mb-2 shadow-sm">
                <div className="flex flex-col md:flex-row items-center justify-center">
                    <div className="flex flex-col items-center justify-center mb-4 md:mb-0 md:mr-6">
                        <div className="bg-white p-3 rounded-lg shadow-md mb-3">
                            <QRCode
                                id={`qr-${assetNumber}`}
                                value={tagDetailValue}
                                size={150}
                                level={'H'}
                                renderAs="svg"
                            />
                        </div>
                        <p className="text-scogoorange font-medium text-center text-sm">
                            Click Print to tag the Asset to this QR
                        </p>
                    </div>

                    <div className="flex-1 bg-white p-4 rounded-lg shadow-md flex flex-col justify-between max-h-max">
                        <div>
                            <div className="border-l-4 border-scogoorange pl-3 mb-4">
                                <h3 className="text-xl font-bold text-gray-800 mb-1">
                                    Asset ID: {assetNumber}
                                </h3>
                                <p className="text-gray-600 text-sm">
                                    <span className="font-semibold">Customer:</span> {organizationName}
                                </p>
                            </div>

                            <div className="flex flex-col space-y-2">
                                {asset?.asset?.asset_type && (
                                    <div className="flex items-center">
                                        <span className="text-gray-500 w-24 text-sm">Asset Type:</span>
                                        <span className="font-medium text-sm">{asset?.asset?.asset_type?.title}</span>
                                    </div>
                                )}
                                {asset?.asset?.status && (
                                    <div className="flex items-center">
                                        <span className="text-gray-500 w-24 text-sm">Status:</span>
                                        <span className={`font-medium text-sm ${asset.asset.status === 'AVAILABLE' ? 'text-green-600' : 'text-blue-600'}`}>
                                            {asset.asset.status}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mt-4 pt-3 border-t border-gray-200">
                            <p className="text-gray-500 text-xs italic flex items-center">
                                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                                Powered by Scogo Networks
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-end space-x-3 px-4 pb-4">
                <ButtonScogoPrimary
                    textOrComponent={
                        <div className="flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                            </svg>
                            Print
                        </div>
                    }
                    onClick={handleSubmit}
                    loading={formButtonLoading?.[formName]}
                />
                <ButtonScogoClosedOutlined textOrComponent={'Cancel'} onClick={closeModal} />
            </div>
        </div>
    );
};

export default DownloadQR;
